export class NmlsLicenseApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanyNmlsLicenses({ companyId, config = {} }) {
    return this.#http.get(`/api/nmls/companies/${companyId}/licenses`, config);
  }

  async getSubCompanyNmlsLicenses({ subCompanyId, config = {} }) {
    return this.#http.get(`/api/nmls/sub-companies/${subCompanyId}/licenses`, config);
  }

  async syncCompanyLicensesFromNmls({ companyId }) {
    return this.#http.post(`/api/nmls/companies/${companyId}/licenses/sync`, {});
  }

  async syncSubCompanyLicensesFromNmls({ subCompanyId }) {
    return this.#http.post(`/api/nmls/sub-companies/${subCompanyId}/licenses/sync`, {});
  }
}
